import { AxiosArgs, ThenArgs, Assessment } from 'src/api/types';
import axios, { AxiosResponse } from 'axios';
import { encodeBody } from 'src/api/client';
import { FormValuesScenarios, WizardFormValues } from './types/wizard';

type WizCreateAssessment = (data: WizardFormValues) => Promise<AxiosArgs<ThenArgs<AxiosResponse<Assessment>>>>;

export const wizCreateAssessment: WizCreateAssessment = (data) => {
  const path = `/api/public/api/wizard/assessment`;
  return axios({
    url: path,
    method: 'POST',
    data: encodeBody(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};
// ------------------------------------------------------------

type UpdateWizard = (params: { data: Partial<WizardFormValues> }) => Promise<AxiosArgs<ThenArgs<AxiosResponse<unknown>>>>;

export const updateWizard: UpdateWizard = ({ data }) => {
  const path = `/api/public/api/workspaces/questions`;
  return axios({
    url: path,
    method: 'POST',
    data: encodeBody(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};
// ------------------------------------------------------------

type WizCreateScenarios = (params: {
  data: { scenarios: FormValuesScenarios };
  id: string;
}) => Promise<AxiosArgs<ThenArgs<AxiosResponse<unknown>>>>;

export const wizCreateScenarios: WizCreateScenarios = ({ data, id }) => {
  const path = `/api/public/api/wizard/assessment/scenarios`;
  return axios({
    url: path,
    method: 'POST',
    data: encodeBody({ ...data, assessment: { id } }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};
// ------------------------------------------------------------
